import { render } from "./supporting_materials_section.vue?vue&type=template&id=3e5ebd1f"
import script from "./supporting_materials_section.vue?vue&type=script&lang=js"
export * from "./supporting_materials_section.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__